export function containsAny(
  targetString: string,
  searchStrings: string[]
): boolean {
  return searchStrings.some((searchString) =>
    targetString.includes(searchString)
  );
}
